import { ReactComponent as ChevronDown } from 'assets/icons/icon-chevron-down.svg';

export default ChevronDown;
